import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Form } from "@rjsf/mui";
import validator from '@rjsf/validator-ajv8';
import { useEffect, useState } from "react";
import * as apiClient from "../api";
import { CalculatorCriteria } from "../types/calculator";
import { calculatorFormSchema, calculatorUiSchema } from "../types/rjsfSchema/calculator";

interface QuestionJsonDialogProps {
  open: boolean;
  handleClose: () => void;
  variant: "add" | "edit";
  calculatorId?: string;
  onChange: () => void;
}

const CalculatorJsonDialog = ({ open, handleClose, variant, calculatorId, onChange }: QuestionJsonDialogProps) => {


  console.log(calculatorId);

  const [calculatorLoaded, setCalculatorLoaded] = useState(false);
  const [calculatorCriteria, setCalculatorCriteria] = useState<CalculatorCriteria | null>(null);
  const [questionsLoaded, setQuestionsLoaded] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (variant === "edit" && calculatorId) {
      apiClient.getCalculatorCriteria(calculatorId).then((res) => {
        setCalculatorCriteria(res.data);
        setCalculatorLoaded(true);
      })
    } else {
      setCalculatorCriteria(null);
      setCalculatorLoaded(true);
    }

    apiClient.getQuestions().then((res) => {
      setQuestions(res.data.questions);
      setQuestionsLoaded(true);
    });
  }, [calculatorId, variant]);

  const dialogTitle = variant === "add" ? "Add Calculator" : `Edit ${calculatorId ? calculatorId : "Calculator"}`;


  const onSubmit = async (data: CalculatorCriteria) => {
    if (variant === "add") {
      await apiClient.addCalculator(data);
    } else if (calculatorId) {
      await apiClient.editCalculator(data);
    }

    handleClose();
    onChange();
  }


  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={"xl"}>
      {
        !(calculatorLoaded && questionsLoaded) ? <DialogTitle>Loading...</DialogTitle> :
          <>
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent>
              <Form schema={calculatorFormSchema("add", questions)} formData={calculatorCriteria} uiSchema={calculatorUiSchema()} validator={validator} onSubmit={(data) => { onSubmit(data.formData as CalculatorCriteria) }} />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
          </>
      }
    </Dialog>
  )
}

export default CalculatorJsonDialog;